import CircularProgress from '@mui/material/CircularProgress';
import { useWorkspaces } from '@provisioning/react';
import React, { Suspense } from 'react';
import { ArtifactSelector, ArtifactSelectorFormData } from './ArtifactSelector';

export const WorkspaceSelector = ({
  title,
  onChange,
  required,
  formData,
}: {
  title: string;
  onChange: Function;
  required: boolean;
  formData: ArtifactSelectorFormData | undefined;
}) => {
  const { data: options } = useWorkspaces({ owned: true });

  return (
    <Suspense fallback={<CircularProgress />}>
      <ArtifactSelector
        title={title}
        onChange={onChange}
        required={required}
        options={options}
        formData={formData}
      />
    </Suspense>
  );
};
